<template>
  <div class="admin-page dark">
		<InsideBanner />
		<h1 class="inside_page_name">Admin</h1>
		<b-alert show variant="primary" class="lert" dismissible v-if="added">
			Piece has been added <b>&rArr;</b>
		</b-alert>

    <section class="new-piece">
       <button class="custom-button" v-b-modal.modalForm v-if="userIsAuthenticated">Create Piece</button>
    </section>
    <section class="existing-pieces">
      <h1 v-if="userIsAuthenticated">Existing Pieces</h1>
      <PiecesCard :pieces='loadedPieces' style="margin-bottom:3rem;" />
    </section>
    <!-- Modal -->
		<Form  @pieceAdded="added = true" @closeIt="added = false" />

  </div>
</template>

<script>
import PiecesCard from '@/components/PiecesCard'
import Form from '@/components/admin/Form'
import InsideBanner from '@/components/InsideBanner'
export default {
	data() {
		return {
			added: false
		}
	},
	components: {
		PiecesCard,
		Form,
		InsideBanner
	},
	computed: {
		loadedPieces() {
			return this.$store.getters.loadedPieces
		},
		userIsAuthenticated() {
			return (
				this.$store.getters.user !== null &&
				this.$store.getters.user !== undefined
			)
		}
	},
	watch: {
		user(value) {
			if (value == null || value == undefined) {
				this.$router.push('/')
			}
		}
	}
}
</script>

